export function getAnonId(): string {
  let id = localStorage.getItem('ld_anon_id');
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem('ld_anon_id', id);
  }
  return id;
}
